import types from './types';
import globalTypes from '../types';
import email_confirmation from '../../selectors/modals/email_confirmation';

const InitialState = {
    modal: null,
    data: {
        facebook_share: {
            post: {
                id: null,
                url: null
            },
            button: false
        },
        facebook_story: {
            post: {
                id: null,
                url: null
            },
            button: false
        },
        account_recovery: {
            stage: 'choose',
            choose: {},
            username: {
                error: null,
                button: false
            },
            password_enter: {
                error: null,
                button: false
            },
            password_code: {
                error: null,
                data: {
                    type: '',
                    value: '',
                    timestamp: 0
                },
                button: false,
                resend_button: false
            }
        },
        email_confirmation: {
            stage: 'unconfirmed',
            unconfirmed: {
                error: null,
                button: false
            },
            confirmation: {
                error: null,
                button: false,
                resend_button: false
            }
        },
        phone_confirmation: {
            stage: 'unconfirmed',
            unconfirmed: {
                error: null,
                button: false
            },
            confirmation: {
                error: null,
                button: false,
                resend_button: false
            }
        },
        profile_complete: {
            game: null,
            error: "",
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            username: "",
            password: "",
            button: false
        },
        signup: {
            error: "",
            phone: "",
            email: "",
            username: "",
            password: "",
            checkbox: false,
            button: false
        },
        signin: {
            error: "",
            username: "",
            password: "",
            button: false
        },
        addcash: {
            amount: 15,
            game: null,
            button: false
        },
        testyourluck_add: {game: null},
        freeplay_add: {game: null, button: false},
        freeplay_loot: {game: null, button: false},
        wallet: {
            mode: "tabs",
            method: null,
            tab: "deposit"
        },
        cashout: {game: null},
        login_ready: {game: null},
        login_remove: {game: null},
        login_reset: {game: null},
        login_reset_done: {game: null},
        cashout_failed: {transactionId: null, reason: 'unknown'},
        deposit_failed: {transactionId: null, reason: 'unknown'},
        deposit_success: {transactionId: null},
        game: {game: null},
        download: {game: null, code: false},
        changeGame: {handler: null},

        wallet_deposit_success: {transactionId: null},
        wallet_deposit_failed: {transactionId: null}
    }
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.account_recovery.error:
            return {
                ...state,
                data: {
                    ...state.data,
                    account_recovery: {
                        ...state.data.account_recovery,
                        [state.data.account_recovery.stage]: {
                            ...state.data.account_recovery[state.data.account_recovery.stage],
                            error: payload
                        }
                    }
                }
            }
        case types.account_recovery.stage:
            return {
                ...state,
                data: {
                    ...state.data,
                    account_recovery: {
                        ...state.data.account_recovery,
                        stage: payload
                    }
                }
            }
        case types.account_recovery.toggle_button:
            return {
                ...state,
                data: {
                    ...state.data,
                    account_recovery: {
                        ...state.data.account_recovery,
                        [state.data.account_recovery.stage]: {
                            ...state.data.account_recovery[state.data.account_recovery.stage],
                            button: !state.data.account_recovery[state.data.account_recovery.stage].button
                        }
                    }
                }
            }
        case types.account_recovery.toggle_resend:
            return {
                ...state,
                data: {
                    ...state.data,
                    account_recovery: {
                        ...state.data.account_recovery,
                        [state.data.account_recovery.stage]: {
                            ...state.data.account_recovery[state.data.account_recovery.stage],
                            resend_button: !state.data.account_recovery[state.data.account_recovery.stage].resend_button
                        }
                    }
                }
            }
        case types.account_recovery.update_stage:
            return {
                ...state,
                data: {
                    ...state.data,
                    account_recovery: {
                        ...state.data.account_recovery,
                        [state.data.account_recovery.stage]: {
                            ...state.data.account_recovery[state.data.account_recovery.stage],
                            ...payload
                        }
                    }
                }
            }
        // 
        case types.phone_confirmation.error:
            return {
                ...state,
                data: {
                    ...state.data,
                    phone_confirmation: {
                        ...state.data.phone_confirmation,
                        [state.data.phone_confirmation.stage]: {
                            ...state.data.phone_confirmation[state.data.phone_confirmation.stage],
                            error: payload
                        }
                    }
                }
            }
        case types.phone_confirmation.stage:
            return {
                ...state,
                data: {
                    ...state.data,
                    phone_confirmation: {
                        ...state.data.phone_confirmation,
                        stage: payload
                    }
                }
            }
        case types.phone_confirmation.toggle_button:
            return {
                ...state,
                data: {
                    ...state.data,
                    phone_confirmation: {
                        ...state.data.phone_confirmation,
                        [state.data.phone_confirmation.stage]: {
                            ...state.data.phone_confirmation[state.data.phone_confirmation.stage],
                            button: !state.data.phone_confirmation[state.data.phone_confirmation.stage].button
                        }
                    }
                }
            }
        case types.phone_confirmation.toggle_resend:
            return {
                ...state,
                data: {
                    ...state.data,
                    phone_confirmation: {
                        ...state.data.phone_confirmation,
                        [state.data.phone_confirmation.stage]: {
                            ...state.data.phone_confirmation[state.data.phone_confirmation.stage],
                            resend_button: !state.data.phone_confirmation[state.data.phone_confirmation.stage].resend_button
                        }
                    }
                }
            }
        case types.phone_confirmation.update_stage:
            return {
                ...state,
                data: {
                    ...state.data,
                    phone_confirmation: {
                        ...state.data.phone_confirmation,
                        [state.data.phone_confirmation.stage]: {
                            ...state.data.phone_confirmation[state.data.phone_confirmation.stage],
                            ...payload
                        }
                    }
                }
            }
        // 
        case types.email_confirmation.error:
            return {
                ...state,
                data: {
                    ...state.data,
                    email_confirmation: {
                        ...state.data.email_confirmation,
                        [state.data.email_confirmation.stage]: {
                            ...state.data.email_confirmation[state.data.email_confirmation.stage],
                            error: payload
                        }
                    }
                }
            }
        case types.email_confirmation.stage:
            return {
                ...state,
                data: {
                    ...state.data,
                    email_confirmation: {
                        ...state.data.email_confirmation,
                        stage: payload
                    }
                }
            }
        case types.email_confirmation.toggle_button:
            return {
                ...state,
                data: {
                    ...state.data,
                    email_confirmation: {
                        ...state.data.email_confirmation,
                        [state.data.email_confirmation.stage]: {
                            ...state.data.email_confirmation[state.data.email_confirmation.stage],
                            button: !state.data.email_confirmation[state.data.email_confirmation.stage].button
                        }
                    }
                }
            }
        case types.email_confirmation.toggle_resend:
            return {
                ...state,
                data: {
                    ...state.data,
                    email_confirmation: {
                        ...state.data.email_confirmation,
                        [state.data.email_confirmation.stage]: {
                            ...state.data.email_confirmation[state.data.email_confirmation.stage],
                            resend_button: !state.data.email_confirmation[state.data.email_confirmation.stage].resend_button
                        }
                    }
                }
            }
        case types.email_confirmation.update_stage:
            return {
                ...state,
                data: {
                    ...state.data,
                    email_confirmation: {
                        ...state.data.email_confirmation,
                        [state.data.email_confirmation.stage]: {
                            ...state.data.email_confirmation[state.data.email_confirmation.stage],
                            ...payload
                        }
                    }
                }
            }
        case globalTypes.user.logout:
            return InitialState;
        case types.wallet.preset:
            return {
                ...state,
                data: {
                    ...state.data,
                    wallet: {
                        ...state.data.wallet,
                        mode: payload.mode || state.data.wallet.mode,
                        tab: payload.tab || state.data.wallet.tab,
                        method: payload.method || state.data.wallet.method
                    }
                }
            }
        case types.wallet.tab:
            return {
                ...state,
                data: {
                    ...state.data,
                    wallet: {
                        ...state.data.wallet,
                        tab: payload
                    }
                }
            }
        case types.reset:
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload]: InitialState.data[payload]
                }
            }
        case types.downloadCode:
            return {
                ...state,
                data: {
                    ...state.data,
                    download: state.data.download.game === payload.game ? {
                        ...state.data.download,
                        code: payload.code
                    } : state.data.download
                }
            }
        case types.update:
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.slug]: {
                        ...state.data[payload.slug],
                        ...payload.data
                    }
                }
            }
        case types.set:
            return {
                ...state,
                modal: payload
            }
        default:
            return state;
    }
}